import React from 'react';
import { Box, Typography } from '@mui/material';
import BalanceManager from '../components/BalanceManager';

const Balances = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Balances</Typography>
      <BalanceManager />
    </Box>
  );
};

export default Balances;
